import { render } from "./specialG.vue?vue&type=template&id=0f7e477d&scoped=true"
import script from "./specialG.vue?vue&type=script&lang=js"
export * from "./specialG.vue?vue&type=script&lang=js"

import "./specialG.vue?vue&type=style&index=0&id=0f7e477d&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f7e477d"]])

export default __exports__